module.exports = __webpack_public_path__ + "img/mi-question-answer.f60af915.svg";